import React, { useState, useEffect } from 'react';
import { BackgroundColor, PrimaryColor, WarningColor } from 'styles/Global/colorSemantic';

const SelectRedCheckBox = ({ $disabled, $width, $height, $marginRight }: { $disabled?: boolean; $width?: string; $height?: string; $marginRight?: string }) => {
    const [fillColor, setFillColor] = useState(WarningColor.color_warning_normal);

    useEffect(() => {
        const svgElement = document.getElementById('red-checkbox-svg');

        if ($disabled) {
            setFillColor(WarningColor.color_warning_normal_disabled);
        } else {
            const handleMouseOver = () => {
                if (!$disabled) {
                    setFillColor(WarningColor.color_warning_normal_hover);
                }
            };

            const handleMouseOut = () => {
                if (!$disabled) {
                    setFillColor(WarningColor.color_warning_normal);
                }
            };

            const handleMouseDown = () => {
                if (!$disabled) {
                    setFillColor(WarningColor.color_warning_normal_press);
                }
            };

            const handleMouseUp = () => {
                if (!$disabled) {
                    setFillColor(WarningColor.color_warning_normal);
                }
            };

            const handleFocus = () => {
                if (!$disabled) {
                    setFillColor(WarningColor.color_warning_normal_press);
                }
            };

            const handleBlur = () => {
                if (!$disabled) {
                    setFillColor(WarningColor.color_warning_normal);
                }
            };

            svgElement?.addEventListener('mouseover', handleMouseOver);
            svgElement?.addEventListener('mouseout', handleMouseOut);
            svgElement?.addEventListener('mousedown', handleMouseDown);
            svgElement?.addEventListener('mouseup', handleMouseUp);
            svgElement?.addEventListener('focus', handleFocus);
            svgElement?.addEventListener('blur', handleBlur);

            return () => {
                svgElement?.removeEventListener('mouseover', handleMouseOver);
                svgElement?.removeEventListener('mouseout', handleMouseOut);
                svgElement?.removeEventListener('mousedown', handleMouseDown);
                svgElement?.removeEventListener('mouseup', handleMouseUp);
                svgElement?.removeEventListener('focus', handleFocus);
                svgElement?.removeEventListener('blur', handleBlur);
            };
        }
    }, [$disabled]);

    return (
        <svg style={{ marginRight: $marginRight || 0 }} id='red-checkbox-svg' width={$width || '28'} height={$height || '28'} viewBox='0 0 28 28' fill='none' xmlns='http://www.w3.org/2000/svg'>
            <path d='M0.5 20C0.5 24.4183 4.08172 28 8.5 28L20.5 28C24.9183 28 28.5 24.4183 28.5 20L28.5 8C28.5 3.58172 24.9183 0 20.5 0L8.5 0C4.08172 0 0.5 3.58172 0.5 8L0.5 20Z' fill={fillColor} />
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M21.2071 9.29289C21.5976 9.68342 21.5976 10.3166 21.2071 10.7071L13.2071 18.7071C12.8166 19.0976 12.1834 19.0976 11.7929 18.7071L7.79289 14.7071C7.40237 14.3166 7.40237 13.6834 7.79289 13.2929C8.18342 12.9024 8.81658 12.9024 9.20711 13.2929L12.5 16.5858L19.7929 9.29289C20.1834 8.90237 20.8166 8.90237 21.2071 9.29289Z'
                fill='white'
            />
        </svg>
    );
};

export default SelectRedCheckBox;
